export const isStateEq = (state: string, expected: string): boolean => state === expected;

export const isCanceledByUser = (state: string): boolean => isStateEq(state, 'canceled_by_user');

export const isCanceledByAdmin = (state: string): boolean => isStateEq(state, 'canceled') || isStateEq(state, 'canceled_by_admin');

export const isCalculated = (state: string): boolean => isStateEq(state, 'calculated');

export const isActive = (state: string): boolean => isStateEq(state, 'active');
